import React from 'react';
import 'twin.macro';
import { BreadcrumbDivider } from './BreadcrumbDivider';

export function BreadcrumbItemWrapper(props: {
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <li tw="min-w-0" className={props.className}>
      <div tw="flex items-center gap-x-0 min-w-0">
        <BreadcrumbDivider />
        <div tw="flex-1 min-w-0">{props.children}</div>
      </div>
    </li>
  );
}
